interface StatusItem {
    title: string;
    subtitle: string;
    status: string;
    color?: "green" | "blue" | "yellow" | "orange" | "red";
}

interface StatusListCardProps {
    title: string;
    accent: string;
    items: StatusItem[];
}

export function StatusListCard({
    title,
    accent,
    items,
}: StatusListCardProps) {

    const colors = {
        green: "bg-green-100 text-green-700",
        blue: "bg-blue-100 text-blue-700",
        yellow: "bg-yellow-100 text-yellow-700",
        orange: "bg-orange-100 text-orange-700",
        red: "bg-red-100 text-red-700",
    };

    return (
        <div className="rounded-2xl border border-border bg-card p-5">

            <h3 className="text-sm font-semibold">
                {title}
            </h3>

            <div className="mt-5 space-y-4">

                {items.map((item) => (

                    <div
                        key={item.title}
                        className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                    >

                        <div>

                            <p className="font-medium">
                                {item.title}
                            </p>

                            <p className="text-xs text-muted-foreground">
                                {item.subtitle}
                            </p>

                        </div>

                        <span
                            className={`rounded-full px-3 py-1 text-xs font-semibold ${
                                colors[item.color ?? "blue"]
                            }`}
                            style={
                                item.color
                                    ? undefined
                                    : {
                                          background: `${accent}15`,
                                          color: accent,
                                      }
                            }
                        >
                            {item.status}
                        </span>

                    </div>

                ))}

            </div>

        </div>
    );
}